// The single definition of how a role literal is shown to a human. Mirrors
// Role.displayName() on the server
// (backend/src/main/java/com/example/docformmgmt/model/Role.java).
//
// WHY THIS EXISTS. Three components each carried their own formatRole() that
// title-cased the enum literal, and four badges inlined role.replace(/_/g,' ').
// That made the DISPLAY NAME a function of the STORED LITERAL: renaming the role
// silently renamed the label too, and — worse — a label could never be changed
// without changing the literal. ORG-05 (#300) is exactly that change, so it is
// where the coupling goes. One map, one place.
//
// This module imports NOTHING, deliberately. It is pulled in by components and by
// Sidebar, and a dependency on authService.js would create a cycle through
// api.js. errors.js and toastBus.js are kept dependency-free for the same reason.
export const ROLE_LABELS = Object.freeze({
  INITIAL_ADMIN: 'Platform administrator',
  AGENCY_ADMIN: 'Agency administrator',
  GROUP_ADMIN: 'Group administrator',
  REGULAR_USER: 'User',
});

/**
 * Label for a role literal. Falls back to a readable rendering of an UNKNOWN
 * literal rather than blanking it: this is an operational tool, and a role badge
 * that silently disappears is worse than one that reads oddly. The four known
 * roles never take the fallback path.
 */
export const roleLabel = (role) => {
  if (!role) return '';
  return (
    ROLE_LABELS[role] ||
    role.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (l) => l.toUpperCase())
  );
};
